import TestService from '@boServices/testService';
import { useCallback, useEffect, useState } from 'react';

const testService = new TestService();

// Test shown by the detail page. `setTest` replaces it after a save, or takes a function of the shown
// test that returns the new one, as a state setter does. Once another test is shown, it does nothing.
const useTest = (reference) => {
    // Last answer, tagged with its reference: while another test loads, nothing of the previous one is exposed.
    const [loaded, setLoaded] = useState({ reference: null, test: null, error: null });

    useEffect(() => {
        // A late answer for a previous reference must not overwrite the current test.
        let cancelled = false;
        testService
            .getTest(reference)
            .then((test) => {
                if (!cancelled) setLoaded({ reference, test, error: null });
            })
            .catch((error) => {
                if (!cancelled) setLoaded({ reference, test: null, error });
            });
        return () => {
            cancelled = true;
        };
    }, [reference]);

    const setTest = useCallback(
        (next) =>
            setLoaded((current) => {
                if (current.reference !== reference) return current;
                return { reference, test: typeof next === 'function' ? next(current.test) : next, error: null };
            }),
        [reference],
    );

    const isLoaded = loaded.reference === reference;

    return {
        test: isLoaded ? loaded.test : null,
        loading: !isLoaded,
        error: isLoaded ? loaded.error : null,
        setTest,
    };
};

export default useTest;
